module.exports = __webpack_public_path__ + "img/logo-white.83d3c9c7.png";